import { CREATE_NOTIFICATION, GET_NOTIFICATIONS } from 'client/api';
import { client } from 'client/request';

import { combineUrlParams } from 'utils';

const post = (body) => {
  return new Promise((resolve, reject) => {
    client
      .post(CREATE_NOTIFICATION, body)
      .then((res) => {
        const { data } = res;

        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAllNotifications = (params) => {
  const url = combineUrlParams(GET_NOTIFICATIONS, params);

  return new Promise((resolve, reject) => {
    client
      .get(url, {})
      .then((res) => {
        const { data } = res;

        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default { post, getAllNotifications };
